import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
  selectCombatResults,
  selectCombatStats,
  selectPlayers,
} from '../../../redux/reducers/sharedStateReducer/selectors';
import {selectCarriedCombatResults} from '../../../redux/reducers/privateStateReducer/selectors';
import {selectIsCombatResultsModalVisible} from '../../../redux/selectors/modalVisibility';
import {clearCombatResults, hideCombatResultsModal} from '../../../redux/actions';
import './CombatResultsModal.css';
import {REGISTRY_SINGLETON} from "../../../scenes/Registry";
import {useEffectOnPositiveChange} from "../../../hooks/react/useEffectOnPositiveChange";
import ModalWindow from "../ModalWindow/ModalWindow";
import ModalButton from "../ModalWindow/ModalButton/ModalButton";
import {buildCombatResultsRows} from "./buildCombatResultsRows";
import CombatResultsStatsRow from "./CombatResultsStatsRow";

/**
 * Итоги этапа боя, на котором уничтожены отряды (ближний бой, стрельба,
 * ловушки), — по аналогии с итогами раунда и захватом городов: плашка на
 * каждого игрока, у которого на этапе что-то изменилось (см.
 * buildCombatResultsRows), с уничтоженными и потерянными отрядами, нанесенным
 * уроном, потерей размера отрядов и очками за бой. Итоги этапов, идущих в ходе
 * перед ближним боем, ждут его конца и показываются вместе с ним
 */
const CombatResultsModal = () => {
  const dispatch = useDispatch();
  const combatResults = useSelector(selectCombatResults);
  const combatStats = useSelector(selectCombatStats);
  const players = useSelector(selectPlayers);
  const carried = useSelector(selectCarriedCombatResults);

  // Видимость считает общий селектор: ее же спрашивают итоги раунда и итоги
  // матча, и все обязаны понимать «модалка на экране» одинаково. Захвату
  // городов конца раунда (облет и его модалка) эта модалка уступает очередь
  const showModalFinal = useSelector(selectIsCombatResultsModalVisible);

  useEffectOnPositiveChange(showModalFinal, () => {
    const soundManager = REGISTRY_SINGLETON.getSoundManager();
    soundManager.playModalCombatResults();
  });

  if (!showModalFinal) {
    return null;
  }

  const handleClose = () => {
    dispatch(clearCombatResults());
    dispatch(hideCombatResultsModal());
  };

  const rows = buildCombatResultsRows(combatStats, combatResults, players, carried?.stats);
  const killedCount = combatResults.length + (carried?.results.length || 0);
  const headerText = killedCount > 1 ? 'Отряды уничтожены!' : 'Отряд уничтожен!';

  return (
    <ModalWindow
      handleClose={handleClose}
      className={'combat-results-modal'}
    >
      <div className="combat-results-modal-header">
        <h2>{headerText}</h2>
      </div>

      <div className="combat-results-modal-content">
        <div className="combat-results-modal-players">
          <div className="combat-results-modal-columns" aria-hidden={'true'}>
            <span className="combat-results-modal-column_size">Потери</span>
            <span className="combat-results-modal-column_damage">Урон</span>
            <span className="combat-results-modal-column_points">Очки</span>
          </div>
          {rows.map((row) => (
            <CombatResultsStatsRow key={row.player.id} row={row} players={players}/>
          ))}
        </div>
      </div>

      <div className="combat-results-modal-footer">
        <ModalButton
          onClick={handleClose}
          text={'Продолжить'}
        />
      </div>
    </ModalWindow>
  );
};

export default CombatResultsModal;
